module.exports = __webpack_public_path__ + "img/av117.39eb006e.png";